module.exports = __webpack_public_path__ + "static/media/02.b98781b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/_portfolio/02.jpg
// module id = 283
// module chunks = 0